import { Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CertificateLanguage } from '../../certificate/types/Certificate';

type OpenClassCertificateLanguageModalProps = {
  languages: CertificateLanguage[];
  open: boolean;
  saving: boolean;
  onCancel: () => void;
  onConfirm: (languageId: CertificateLanguage['id']) => void;
};

const OpenClassCertificateLanguageModal: React.FC<
  OpenClassCertificateLanguageModalProps
> = ({ languages, open, saving, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [languageId, setLanguageId] = useState<CertificateLanguage['id']>();

  useEffect(() => {
    if (open) setLanguageId(undefined);
  }, [open]);

  return (
    <Modal
      cancelText={t('common.cancel')}
      confirmLoading={saving}
      okButtonProps={{ disabled: languageId == null }}
      okText={t('common.confirm')}
      open={open}
      title={t('components.OpenClassAttendeeActions.certificateLanguage')}
      onCancel={onCancel}
      onOk={() => languageId != null && onConfirm(languageId)}>
      <label className="block">
        <span className="mb-1 block">{t('common.language')}</span>
        <Select
          className="w-full"
          options={languages.map(({ id, name }) => ({
            label: name,
            value: id,
          }))}
          value={languageId}
          onChange={setLanguageId}
        />
      </label>
    </Modal>
  );
};

export default OpenClassCertificateLanguageModal;
